module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Black-WebS-fa2b0e922a98f1fd0a84e2d46558e482.woff2";